<div class="col-md-12 mb-30"  >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Seniority Benefit List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Year </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">Year 1403</option>
            <option value="1404">Year 1404</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Year</th>
              <th>Seniority Benefit (IRR)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Salary.indexOf(item)+1}}</td>
              <td>{{item.day}}</td>
              <input [(ngModel)]="item.sanavat" type="number" />
              <td>
                <button (click)="SubmitAddNewSalary(item)" type="button" class="btn btn-success" style="margin-right: 5px;"><i
                  class="fa  fa-plus-circle"></i> Edit </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

